import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../../common/AutoBindComponent";

import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as exceptionActions from "../../../actions/exceptionActions";
import * as types from "../../../constants/ComponentConstants";
import VRBeoordelingscriteriaForm from "./VRBeoordelingscriteriaForm";
import VRBeoordelingscriteriaPageHelper from "./VRBeoordelingscriteriaPageHelper";
import * as vrLayoutActions from "../../../actions/voortgangsrapportLayoutActions";
import * as beadActions from "../../../actions/beadActions";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";

import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";

class VRBeoordelingscriteriaPage extends AutoBindComponent {
	constructor(props) {
		super(props);

		this.state = {
			vrBeoordelingscriteria: {
				hasValidationErrors: null
			},
			errors: {},
			hasUnsavedChanges: false
		};

		this.pageHelper = new VRBeoordelingscriteriaPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.VOORTGANGSRAPPORT_BEOORDELINGSCRITERIA);
	}

	componentDidMount() {
		this.pageHelper.init();
		this.easterEggHandler.bind();
	}
	componentWillUnmount() {
		this.easterEggHandler.unbind();
	}

	componentWillMount() {
		
	}

	handleOnChange(event, data) {
		this.pageHelper.onChange(event, data);
	}

	handleOnSave() {
		this.pageHelper.onSave();
	}

	isReadyToRender() {
		return !!this.state.vrBeoordelingscriteria
			&& this.state.vrBeoordelingscriteria.id;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}

		const vrBeoordelingscriteria = this.state.vrBeoordelingscriteria;

		return (
			<VRBeoordelingscriteriaForm
				vrBeoordelingscriteria={vrBeoordelingscriteria}
				disabled={this.props.disableInput}
				errors={this.state.errors}
				color={types.COLOR_ORANGE}
				onChange={this.handleOnChange}
				onSave={this.handleOnSave}
				sportVlaanderenIconsURL={this.props.sportVlaanderenIconsURL}
				validationMessageType={this.props.validationMessageType}
			/>
		);
	}
}

VRBeoordelingscriteriaPage.propTypes = {
	vrProjectId: PropTypes.string,
	isNew: PropTypes.bool,
	loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
	const vrProjectId = ownProps.params.vrProjectId;
	const isNew = ownProps.route.params.isNew;
	const disableInput = state.layout.disableInputComponents;
	const vrLoaded = state.voortgangsrapportLoaded;
	const sportVlaanderenIconsURL = state.settings.sportVlaanderenIconsURL;

	return {
		vrProjectId,
		isNew,
		disableInput,
		vrLoaded,
		sportVlaanderenIconsURL,
		validationMessageType: state.voortgangsrapportLoaded.hasValidationErrors ? types.ValidationMessageTypes.ERROR : types.ValidationMessageTypes.WARNING
	};
}
function mapDispatchToProps(dispatch) {
	return {
		beadsLoaded: bindActionCreators(beadActions.voortgangsrapportBeadsLoaded, dispatch),
		ajaxStarted: bindActionCreators(ajaxActions.started, dispatch),
		ajaxEnded: bindActionCreators(ajaxActions.ended, dispatch),
		ajaxFailed: bindActionCreators(ajaxActions.failed, dispatch),
		throwException: bindActionCreators(exceptionActions.throwException, dispatch),
		loadLayout: bindActionCreators(vrLayoutActions.loadVRPageLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(VRBeoordelingscriteriaPage));